import api from '@/api'

const module = {
  namespaced: true,
  state: {
    customerInfo: JSON.parse(localStorage.getItem('CUSTOMER_INFO')) || {} // 平台用户信息
  },
  getters: {

  },
  mutations: {
    setData(state, data) {
      state.customerInfo = data
      localStorage.setItem('CUSTOMER_INFO', JSON.stringify(data))
    },
    clearData(state) {
      state.customerInfo = {}
      localStorage.removeItem('CUSTOMER_INFO')
    }
  },
  actions: {
    getCustomerInfo({
      rootState,
      commit
    }) {
      return new Promise(async(resolve, reject) => {
        const res = await api.customer.getDetail({
          userKey: rootState.auth.targetKey
        })
        if (res.code === 0) {
          resolve(res)
          commit('setData', res.data)
        }
      })
    },
    saveCustomer({
      rootState
    }, data) {
      return new Promise(async(resolve, reject) => {
        const res = await api.customer.save({
          customerKey: rootState.auth.targetKey,
          ...data
        })
        if (res.code === 0) {
          resolve(res)
        }
      })
    }
  }
}

export default module



// WEBPACK FOOTER //
// ./src/store/modules/customer.js